import React from 'react';

const OwnerProfile = () => {
  return (
    <div className="container mt-4">
      <h1>My Profile</h1>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Profile Information</h5>
          {/* Profile form will be implemented here */}
        </div>
      </div>
    </div>
  );
};

export default OwnerProfile; 